<template>
    <div v-if="user" class="user-resources absolute animate__animated animate__fadeInDown">
        <div class="container">
            <div class="col-md-6 p-0 m-auto d-flex">
                <ul @click="$emit('changeTab','shop-tab')">
                    <li><img src="/images/token.png">{{ user.tokens.abbr(true) }}</li>
                    <li><img src="/images/diamond.png">{{ user.diamonds.abbr() }}</li>
                    <li v-if="!user.mtsCustomer"><img src="/images/joker.png">{{ user.jokers.abbr() }}</li>
                    <li v-if="!user.mtsCustomer && challengeAccessible"><img src="/images/dandelion.png">{{ user.swappers.abbr() }}</li>
                    <li v-if="!!user.mtsCustomer"><img src="/images/rubins.png">{{ user.mtsCustomerPoints.abbr() }}</li>
                </ul>
                <a @click.prevent="$emit('openProfile')" href="#" class="profile"><img :src="user.avatarUrl != undefined ? user.avatarUrl : '/images/male-default.png'" /></a>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'

const UserResources = Vue.component('user-resources', {
    data () {
        return {
        }
    },
    methods:{
    },
    computed: {
        user() {
            return this.$store.state.auth.user;
        },
        challengeAccessible(){
            return this.$store.state.config.data.challengeAccessible;
        }
    },
})

export default UserResources
</script>